import script from "./CTTPModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CTTPModal.vue?vue&type=script&setup=true&lang=js"

import "./CTTPModal.vue?vue&type=style&index=0&id=606a8e9f&lang=scss"

const __exports__ = script;

export default __exports__